import { Component, OnInit } from '@angular/core';
import { TechnicalserviceCompanyService } from '../../../services/technicalservice-company.service';
import { TechnicalserviceService } from '../../../../technicalservice/services/technicalservice.service';


@Component({
  selector: 'app-list-technicalservice-companies',
  templateUrl: './list-technicalservice-companies.component.html',
  styleUrls: ['./list-technicalservice-companies.component.css'],
  providers:[TechnicalserviceCompanyService, TechnicalserviceService]
})
export class ListTechnicalserviceCompaniesComponent implements OnInit {

  technicalserviceCompanies:any = [];

  constructor(private technicalserviceCompanyService:TechnicalserviceCompanyService, private technicalserviceService:TechnicalserviceService) { }

  ngOnInit() {
    this.getTechnicalserviceCompanies();
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({})
      .subscribe((technicalserviceCompanies) => {
        this.technicalserviceCompanies = technicalserviceCompanies;
      });
  }

  delete(technicalserviceCompany){
    this.technicalserviceService.query({technicalserviceCompany:technicalserviceCompany.id})
    .subscribe((technicalservices) => {
      if (technicalservices.length > 0){
        alert("No se puede borrar debido ha que existen entradas en servicio ténico con este técnico asociado")
      }else{
        this.technicalserviceCompanyService.delete(technicalserviceCompany.id)
        .subscribe((technicalserviceCompany) => {
          this.getTechnicalserviceCompanies()
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/technicalservice-companies/list-technicalservice-companies/list-technicalservice-companies.component.ts